// extracted by mini-css-extract-plugin
module.exports = {"modalCard":"InvestmentLanding_modalCard__1eKkR","radioButton":"InvestmentLanding_radioButton__3XOkZ","active":"InvestmentLanding_active__hDqL5"};